<template>
	<button
		:class="['group-card', { 'group-card--expanded': expanded }]"
		:style="`order: ${sort}`"
		:aria-expanded="expanded"
		type="button"
	>
		<img v-if="icon_url" class="group-card-icon" width="16" height="21" :src="icon_url" :alt="`Иконка для ${name}`" />
		<p class="group-card-name">{{ name }}</p>
		<svg
			class="group-card-chevron"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	</button>
</template>

<script setup lang="ts">
defineProps({
	name: { type: String, required: true },
	icon_url: { type: String },
	expanded: { type: Boolean, default: false },
	sort: { type: Number, default: 0 }
})
</script>

<style lang="scss" scoped>
.group-card {
	padding: 8px 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	background-color: var(--selection-rest);
	border-radius: var(--radius-md);
	font: var(--font-label);
	color: var(--text-brand);
	cursor: pointer;
	transition: $transition-color, $transition-bg;
	box-shadow: var(--shadow-tile);

	&-icon {
		margin-right: 8px;
		object-fit: contain;
	}

	&-chevron {
		margin-left: 6px;
	}

	&--expanded {
		background-color: var(--selection-selected);
		color: var(--text-inverse);
	}
}
</style>
